import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface IMenuIconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const MenuIcon = ({ color, ...props }: IMenuIconProps) => {
  const stroke = color ?? COLORS['base-100'];

  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1"
        width="6"
        height="6"
        rx="1.7"
        stroke={stroke}
        strokeWidth="2"
      />
      <rect
        x="11.5"
        y="1"
        width="6"
        height="6"
        rx="1.7"
        stroke={stroke}
        strokeWidth="2"
      />
      <rect
        x="11.5"
        y="11"
        width="6"
        height="6"
        rx="1.7"
        stroke={stroke}
        strokeWidth="2"
      />
      <rect
        x="1.5"
        y="11"
        width="6"
        height="6"
        rx="1.7"
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
};
